import { ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useTimer from 'hooks/useTimer';

import { createArrayOfArrays, sortCraftingCost } from './helper';
import './style.scss';

const getRepairPerMine = (activeCard, t) => {
  if (activeCard?.requiredForRepairQuantity0To100 == null) return '';
  const cycles = 100 / (activeCard?.healthUsagePerMine ?? 1);
  const quantity = Math.floor(activeCard.requiredForRepairQuantity0To100 / cycles);
  return `${quantity} ${activeCard?.requiredForRepairPairCleaned ?? t('activeCardInfo.goldFallback')}`;
};

const ActiveCardInfo = ({ children, activeCard, isCostInfoExist = true, onTimerEnd }) => {
  const { t } = useTranslation();
  const repairPerMine = getRepairPerMine(activeCard, t);
  const { timeDisplay } = useTimer({
    cardId: activeCard?.assetId,
    mineCycleStartedAt: activeCard?.mineCycleStartedAt,
    miningTime: activeCard?.miningTime,
    onEnd: onTimerEnd,
  });
  return (
    <>
      <div className="card-img-col">
        <img alt={activeCard?.category} className="large-img" src={activeCard?.imageUrl} />
        {!isCostInfoExist ? (
          <div className="w-100 progress-bar-container px-3">
            <h6 className="info-row">{t('activeCardInfo.health')}</h6>
            <ProgressBar className="progress-bar" label={`${activeCard?.health}/100`} now={activeCard?.health} />
          </div>
        ) : null}
      </div>

      <div className="card-info-col info-table-container">
        <div className=" info-table">
          <div className="info-header d-flex align-items-center mb-3">
            <img alt="icon" className="info-icon me-2" src={activeCard?.miningPairImageUrl} />
            <h5 className="info-title mb-0">{activeCard?.asset}</h5>
          </div>

          <div className=" d-flex flex-column">
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.rewardLevel')}</span>
              <span>{activeCard?.rewardLevel}</span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.rewardRate')}</span>
              <span>{activeCard?.miningQuantity}</span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.chargingTime')}</span>
              <span>
                {activeCard?.miningTime} {t('activeCardInfo.mins')}
              </span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.health')}</span>
              <span>{'100' || activeCard?.health}</span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.foodPerMine')}</span>
              <span>{activeCard?.requiredForMineQuantity}</span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.healthPerMine')}</span>
              <span>{activeCard?.healthUsagePerMine}</span>
            </div>
            <div className="info-row d-flex justify-content-between">
              <span>{t('activeCardInfo.repairPerMine')}</span>
              <span>{repairPerMine}</span>
            </div>
            {/* {activeCard?.requiredForCrafting?.map((item, index) => (
              <div className="info-row d-flex justify-content-between" key={index}>
                <span>{item.pair} Per Mine</span>
                <span>{item.quantity}</span>
              </div>
            ))} */}
          </div>
        </div>
        <div className={` info-table ${!isCostInfoExist && 'd-none'}`}>
          <div className=" d-flex flex-column">
            <div className="info-row d-flex justify-content-between">
              {activeCard?.requiredForCrafting?.length ? (
                <span>{t('activeCardInfo.cost')}</span>
              ) : (
                <span style={{ color: '#C56012' }}>
                  {t('activeCardInfo.buyOnlyAt')}
                  <a
                    href={process.env.REACT_APP_ZOGOEX_URL || 'https://zogoex.com'}
                    rel="noreferrer"
                    style={{ color: '#C56012', textDecoration: 'underline' }}
                    target="_blank"
                  >
                    zogoex.com
                  </a>
                </span>
              )}
            </div>
            {activeCard?.requiredForCrafting?.length
              ? createArrayOfArrays(sortCraftingCost(activeCard?.requiredForCrafting))?.map((item, index) => (
                  <div className="info-row d-flex justify-content-between align-items-center" key={index}>
                    {item?.length
                      ? item?.map((item, index) => (
                          <span className="d-flex align-items-center " key={index}>
                            <img alt="icon" className="info-icon cost-img me-2" src={item?.imageUrl} width={20} />
                            {item?.quantity}
                          </span>
                        ))
                      : null}
                  </div>
                ))
              : null}
          </div>
        </div>

        {!isCostInfoExist ? (
          <div className="timer-box">
            <span className="timer-text">{timeDisplay || '00:00:00'}</span>
          </div>
        ) : null}

        {/* buttons */}
        {!isCostInfoExist ? children : activeCard?.requiredForCrafting?.length ? children : null}
      </div>
    </>
  );
};

export default ActiveCardInfo;
